import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { AnomalyPathName } from '@/modules/ta/anomaly/anomaly.constants';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${RouteGroup.ANOMALIES}`,
      name: AnomalyPathName.ANOMALY_ALL,
      component: () => import(/* webpackChunkName: "anomaly-page" */ './pages/AnomalyPage.vue'),
    },
  ],
  Module.ANOMALY
);
